import axios from "axios";
import { useState, useEffect } from "react";
import "./registration.css";
import { BASE_URL } from "./axios";
import { Link, useNavigate } from "react-router-dom";
// import Logo from "../../assets/images/website/loginimage.png"
// import LoginImage from "/assets/image/AimantraFullLogo.png"
import { ToastContainer, toast } from "react-toastify";
import { PasswordEye, PasswordEyeHidden, DropdownArrow } from "../../utils/ReusableSVGs";
import { fetchCountries, fetchStates, fetchCities } from "../../utils/ReusableFunctions";

const Signup = () => {
    const navigate = useNavigate();
    const [errMsg, setErrMsg] = useState("");

    const [formData, setFormData] = useState({
        email: "",
        name: "",
        phone: "",
        country: "",
        state: '',
        city: '',
        street: '',
        pincode: '',
    });


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [showPassword, setShowPassword] = useState(false);


    const validateForm = () => {
        const newErrors = {};
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        }
        else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
            newErrors.email = 'Invalid email format';
        }

        const requiredFields = [
            "email",
            "name",
            "phone",
            "country",
            "state",
            "city",
            "street",
            "pincode",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };





    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {

            const logingToastId = toast.loading(`Logging In...`); //toast Logic

            try {
                let res = await axios.post(`${BASE_URL}/user/login/`, formData);
                console.log(res)
                if (res.status === 200) {
                    const { access, refresh, payload, payload_a } = res.data;
                    const sessionData = {
                        access_token: access,
                        refresh_token: refresh,
                        role: payload.role,
                        email: payload.email,
                        employee_id: payload_a.emp_code,
                        profilepic: payload_a.profilepic,
                        reportinghead: payload_a.reporting_head,
                        department: payload_a.department_name,
                        departmentid: payload_a.department,
                        company: payload_a.division_name,
                        company_id: payload_a.sub_company_id,
                        name: payload_a.name
                    };
                    Object.entries(sessionData).forEach(([key, value]) => sessionStorage.setItem(key, value));
                    window.location.reload();
                    // navigate("/ed");
                }
                else {
                    setErrMsg("Invalid Email Or Password")
                }
            }
            catch (err) {
                console.log(err);
                setErrMsg(err.response.data.error);
                // setErrMsg("Invalid Email Or Password");

                //toast Logic
                if (err.response) {
                    toast.dismiss(logingToastId);
                    const errorData = err.response.data;
                    if (typeof errorData.error === 'string') { // Single error message   
                        toast.error(`Error: ${errorData.error}`);
                    } else if (typeof errorData === 'object' && errorData !== null) {// Multiple error messages
                        Object.entries(errorData).forEach(([field, messages]) => {
                            messages.forEach(message => toast.error(`"${field}": ${message}`));
                        });
                    } else {
                        toast.error('Error:- Failed to Process!');
                    }
                } else {
                    toast.error('Error processing your request.');
                }

            } finally {

                // toast.dismiss(loadingToastId);
            }
        }
        else {
            console.log('Form contains errors:', errors);
        }
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? 'green' : '',
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const gotoLoginpage = () => {
        navigate("/login");
    }

    const handleKeyPress = (event) => {
        // Check if the pressed key is Enter (key code 13)
        if (event.key === 'Enter') {
            event.preventDefault();  // Prevent the default form submission
            handleSubmit(event);
        }
    };

    const [bufferCountries, setBufferingrCountries] = useState(false);
    const [countries, setCountries] = useState([]);
    const [bufferStates, setBufferingrStates] = useState(false);
    const [states, setStates] = useState([]);
    const [bufferCities, setBufferingrCities] = useState(false);
    const [cities, setCities] = useState([]);
    useEffect(() => {
        if (formData.country) fetchStates(formData.country, setStates, setBufferingrStates);
    }, [formData.country]);
    useEffect(() => {
        if (formData.country && formData.state) fetchCities(formData.country, formData.state, setCities, setBufferingrCities);
    }, [formData.state]);



    useEffect(() => {
        fetchCountries(setCountries, setBufferingrCountries);
    }, []);


    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className='login-page'>
                <div>
                    <Link to="/">
                        <img src="/assets/image/loginimage.png" alt='logo' className='login-page-img' />
                    </Link>
                </div>
                <div className='login-page-right'>
                    <div className='login-page-first-heading'>Hello!</div>
                    <div className='login-page-second-heading'>Sign Up</div>
                    <div className='login-page-third-heading'>The world is just a step away from here </div>
                    <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="register-form signup-form">
                        <div className="flex-column">
                            <label htmlFor="name" className='form-labels'>Name <span className="required">*</span></label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="example@gmail.com"
                                autoComplete="off"
                                onChange={handleInputChange}
                                value={formData.name}
                                className={`form-input ${errors.name ? 'error' : inputState.name ? 'success' : ''}`}
                            />
                            {errors.name && (<span className="error-message">{errors.name}</span>)}
                        </div>

                        <div className="flex-column">
                            <label htmlFor="phone" className='form-labels'>Phone Number <span className="required">*</span></label>
                            <input
                                type="number"
                                id="number"
                                name="phone"
                                placeholder="Enter Your Phone Number"
                                autoComplete="off"
                                onChange={handleInputChange}
                                value={formData.phone}
                                className={`form-input ${errors.phone ? 'error' : inputState.phone ? 'success' : ''}`}
                            />
                            {errors.phone && (<span className="error-message">{errors.phone}</span>)}
                        </div>
                        <div className="flex-column">
                            <label htmlFor="email" className='form-labels'>Email <span className="required">*</span></label>
                            <input
                                type="text"
                                id="email"
                                name="email"
                                placeholder="example@gmail.com"
                                autoComplete="off"
                                onChange={handleInputChange}
                                value={formData.email}
                                className={`form-input ${errors.email ? 'error' : inputState.email ? 'success' : ''}`}
                            />
                            {errors.email && (<span className="error-message">{errors.email}</span>)}</div>


                        <div className="flex-column form-group-selectt">
                            <label htmlFor="country" className='form-labels'>Country  <span className="required">*</span></label>
                            <br />
                            {bufferCountries ?
                                <div className="form-loader">
                                    <div className="bar-loader"></div>
                                </div>
                                :
                                <select
                                    name="country"
                                    id="country"
                                    value={formData.country}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.country ? "error" : inputState.country ? "success" : ""}`}
                                >
                                    <option value="">Select Country</option>
                                    {countries.map((country, i) => (
                                        <option key={i} value={country}>{country}</option>
                                    ))}
                                </select>}
                            <DropdownArrow />
                            <div>
                                {errors.country && <span className="error-message font-size-text ">{errors.country}
                                </span>}
                            </div>

                        </div>

                        <div className="flex-column form-group-selectt">
                            <label className='form-labels' htmlFor="state">State  <span className="required">*</span></label>
                            <br />
                            {bufferStates ?
                                <div className="form-loader">
                                    <div className="bar-loader"></div>
                                </div>
                                :
                                <select
                                    name="state"
                                    id="state"
                                    value={formData.state}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.state ? "error" : inputState.state ? "success" : ""}`}
                                >
                                    <option value="">Select State</option>
                                    {states.map((state, i) => (
                                        <option key={i} value={state}>{state}</option>
                                    ))}
                                </select>}
                            <DropdownArrow />
                            <div>
                                {errors.state && <span className="error-message font-size-text ">{errors.state}
                                </span>}
                            </div>
                        </div>

                        <div className="flex-column form-group-selectt">
                            <label className='form-labels' htmlFor="city">City <span className="required">*</span></label>
                            <br />
                            {bufferCities ?
                                <div className="form-loader">
                                    <div className="bar-loader"></div>
                                </div>
                                :
                                <select
                                    name="city"
                                    id="city"
                                    value={formData.city}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.city ? "error" : inputState.city ? "success" : ""}`}
                                >
                                    <option value="">Select City</option>
                                    {cities.map((city, i) => (
                                        <option key={i} value={city}>{city}</option>
                                    ))}
                                </select>}
                            <DropdownArrow />
                            <div>
                                {errors.city && <span className="error-message font-size-text ">{errors.city}
                                </span>}
                            </div>
                        </div>

                        <div className="flex-column">
                            <label className='form-labels' htmlFor="street">Street  <span className="required">*</span></label>
                            <input
                                type="text"
                                name="street"
                                id="street"
                                placeholder="Street Name"
                                required
                                value={formData.street}
                                onChange={handleInputChange}
                                className={`form-input  ${errors.street ? "error" : inputState.street ? "success" : ""}`}
                            />
                            <div>
                                {errors.street && <span className="error-message font-size-text ">{errors.street}
                                </span>}
                            </div>
                        </div>
                        <div className="flex-column">
                            <label className='form-labels' htmlFor="pincode">Pincode <span className="required">*</span></label>
                            <input
                                type="text"
                                name="pincode"
                                id="pincode"
                                placeholder="Pincode"
                                value={formData.pincode}
                                onChange={handleInputChange}
                                className={`form-input n ${errors.pincode ? "error" : inputState.pincode ? "success" : ""}`}
                            />
                            {errors.pincode && (
                                <div className="error-message signup-page-error  font-size-text ">
                                    {errors.pincode}
                                </div>
                            )}</div>

                        <div className="flex">
                            <button className="login-button" onClick={gotoLoginpage}>Login</button>
                        </div>
                        <div className="flex">

                            <button type="submit" className="login-button" >Sign In</button></div>
                        <p
                            style={{ color: "red" }}
                            className={errMsg ? "errmsg" : "offscreen"}
                            aria-live="assertive"
                        >{errMsg}</p>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Signup